import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function GeospatialUnit() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('geospatial_infomation_unit_pdf')}
    title="PDF Document"
  />
</div>

  );
};

export default GeospatialUnit;
